<template>
  <v-app style="background-color:white">
    <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

    <v-card class="form-container" flat style="margin-top:-10px">
      <v-sheet color="transparent" style="text-align:center;padding-top:25px">
                            <v-avatar :size="80" style="background-image: linear-gradient(-180deg, #9e9e9e, #ffff);background-size;border: 1px solid;border-color:black">
                                
                             <img v-if="form.src==null"
                               src="../../assets/dummy.jpg" @click="dash()" style="cursor:pointer"
                             >
                             <img v-if="form.src!=null"
                               :src=form.src @click="dash()" style="cursor:pointer"
                             >
                        </v-avatar>
                        </v-sheet>
                        <div style="text-align:center">
            <v-btn v-if="form.src==null"  small flat depressed @click="shop()"><v-icon color="primary">add_a_photo</v-icon>&nbsp;Add a Photo</v-btn>
            <v-btn v-if="form.src!=null"  small flat depressed @click="shop()"><v-icon color="primary">add_a_photo</v-icon>&nbsp;Change Photo</v-btn>
          
          <v-dialog v-model="dialog" flat width="350px">
       <v-card flat>
         <v-sheet color="transparent" style="text-align:center;padding-top:25px">
                            <v-avatar :size="80" style="background-image: linear-gradient(-180deg, #9e9e9e, #ffff);background-size;border: 1px solid;border-color:black">
                                
                             <img v-if="form.src==null"
                               src="../../assets/dummy.jpg" style="cursor:pointer"
                             >
                             <img v-if="form.src!=null"
                               :src=form.src style="cursor:pointer"
                             >
                        </v-avatar>
                        </v-sheet>

                        <div style="text-align:center">
                          <input type="file" ref="myFile" @change="selectedFile"  class="padding" accept="image/*">
                          <v-btn depressed color="primary" v-if="imageError==''" :loading="btnSave" small @click="onSubmit1(form)">Save</v-btn>
                        </div>
                        <div>
                          <h6 v-if="imagelink != null">Image Size : {{image.size}}</h6>
                          <h6 class="red--text">{{imageError}}</h6>
                        </div>
       </v-card>
     </v-dialog>
          </div>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
            <v-flex xs12 style="padding-bottom:10px">
            <v-switch v-model="edit" label="Want to edit ?" color="primary" hide-details></v-switch>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete
              :disabled="edit === false" 
              v-model="selectedCategory"
              :items="categories"
              color="primary"
              label="Select Category *"
              item-text="categoryName"
              item-value="id"
              :rules="emptyRule" 
              required
            ></v-autocomplete>
          </v-flex>
            <v-flex xs12>
                <v-text-field :disabled="edit === false" v-model="form.categoryName" label="Product Category Name *" :rules="emptyRule" required></v-text-field>
            </v-flex>
            <v-flex xs12>
                <v-text-field :disabled="edit === false" v-model="form.delivery" label="Expected Delivery Time"></v-text-field>
            </v-flex>
            

          <v-flex xs12 sm12 md12 style="text-align:right">
            <v-btn depressed color="#e53935" dark @click="back()">Cancel</v-btn>
            <v-btn :disabled="edit === false" depressed :loading="btnSave" color="primary" dark @click="onSubmit()">Save </v-btn>
          </v-flex>
          
        </v-layout>
      </v-form>
    </v-card>
  </v-app>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      entries: [],
      dialog: false,
      edit: false,
      isLoading: false,
      model: null,
      search: null,
      btnSave: false,

      imagelink: null,
    imageError:'',
    image:{
      size:'',
      height:'',
      width:''
    },
    imageLoaded:false,


      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
      },
      valid: true,
      roleType: sessionStorage.roles,
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Category",
          disabled: false,
          to: "/itemCategory"
        },
        {
          text: "Edit",
          disabled: true,
          to: "/createStudent"
        }
      ],


      form: {
          categoryName: null,
          description: null
      },

      categories: null,
      selectedCategory: null,
    };
  },

  mounted() {
      this.axios
      .get(config.API + `Categories/${this.$route.params.id}`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        this.form = res.data;
        this.selectedCategory = res.data.parentId;
      });

      this.axios
        .get(config.API + "Categories1", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.categories = res.data;
          this.$Progress.finish();
        })
        .catch(err => {
          this.$Progress.fail();
        });
    },

  methods: {
    back() {
      this.$router.go(-1);
    },
    shop() {
      this.dialog = true;
    },

    selectedFile() {
      this.imageLoaded = false;
      this.imageError = '';

      let file = this.$refs.myFile.files[0];
      this.imagelink = file;
      if(!file || file.type.indexOf('image/') !== 0) return;
      
      this.image.size = file.size;

      if(this.image.size > 500000) {
        this.imageError = `The image size (${this.image.size}) is too much (max is 500 KB).`;
        return;
      }
      
      let reader = new FileReader();
      
      reader.readAsDataURL(file);
      reader.onload = evt => {
        let img = new Image();
        img.onload = () => {
          this.image.width = img.width;
          this.image.height = img.height;
          this.imageLoaded = true;
        }
        img.src = evt.target.result;
      }

      reader.onerror = evt => {
        console.error(evt);
      }
    },

    onSubmit1(form) {
      this.btnSave = true;
      const fd = new FormData();
            fd.append("image", this.imagelink, this.imagelink.name);
         this.axios
        .post(config.API + `CategoryImage/${form.id}`, fd, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(() => {
          this.$toaster.success("Successfully Added");
          this.$router.go(-1);
        })
        .catch(err => {
          this.$toaster.error(err.message);
          this.btnSave = false;
        });
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .put(
            config.API + `Categories/${this.$route.params.id}`,
            {
              id: JSON.parse(this.$route.params.id),
              parentId: JSON.parse(this.selectedCategory),
              categoryName: this.form.categoryName,
              delivery: this.form.delivery
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
              this.$toaster.success("Successfully updated");
            this.$router.go(-1);
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    onImage(form) {
      this.$router.push(`/itemCategoryImage/${form.code}`);
    },
  }
};
</script>

<style>
.bckgrnd {
  background-color: #424242;
  background-size:cover !important;
}
img.center {
    display: block;
    margin: 0 auto;
}
.hvr:hover {
  cursor: pointer;
  color: #3486D7;
  text-decoration: underline;
}
</style>
